import { ExcelDownloadBtn } from "components/Buttons/ExcelDownloadBtn";
import { HTTP_METHOD, POST_SETTLE_LIST } from "constants/pathConstant";
import { WALLET_SETTLE_XLSX_DOWNLOAD } from "constants/xlsxDownloadConstant";
import { useExcelDownload } from "hooks/excelDownload/useExcelDownload";
import { useToastCustom } from "hooks/useToastCustom";
import { Info, List, Wrapper } from "template/ListTemplate.style";
import { SettleInfoDetail } from "./SettleInfoDetail";
import swapColumn from "./settleColumn.json";
import { useMutationCustom } from "hooks/useMutationCustom";
import PageHandler from "components/PageHandler/PageHandler";
import { xlsxDateFormat } from "components/xlsxDateFormat";
import { ListDefault } from "components/ListDefault/ListDefault";
import EmptyScreen from "components/EmptyScreen/EmptyScreen";

// 정산 관리 -> 회수 :: 회수 내역 목록 (http://localhost:3000/super/calculate/settle)
export const SettleInfoList = ({
  setPage,
  setSize,
  settleList,
  searchData,
  isSearch,
}) => {
  const excelDownload = useExcelDownload();
  const toast = useToastCustom();

  const { mutate } = useMutationCustom(POST_SETTLE_LIST, HTTP_METHOD.POST);

  // Excel 다운로드
  const handleExcelDownload = () => {
    if (!settleList[0]?.cnt) {
      toast("다운로드할 데이터가 없습니다", "error");
      return;
    }

    const researchCond = {
      ...searchData,
      pageSize: settleList[0]?.cnt,
      currentPage: 1,
    };

    mutate(researchCond, {
      onSuccess: (response) => {
        const updatedResponse = xlsxDateFormat(response);

        const excelData = {
          data: updatedResponse,
          headers: WALLET_SETTLE_XLSX_DOWNLOAD.header,
          fileName: WALLET_SETTLE_XLSX_DOWNLOAD.filename,
        };

        excelDownload(excelData);
      },

      onError: () => {
        toast("데이터 전체 조회 실패", "error");
      },
    });
  };

  return (
    <Wrapper>
      <List.TitleContainer>
        <List.TextContainer>
          <List.Text>회수 내역</List.Text>
        </List.TextContainer>

        <List.BtnContainer>
          {/* 페이지 핸들러 */}
          <PageHandler setPage={setPage} setPageSize={setSize} />
          {/* 엑셀 다운로드 버튼 */}
          <ExcelDownloadBtn onClick={handleExcelDownload} />
        </List.BtnContainer>
      </List.TitleContainer>
      <List.Container>
        {!isSearch && <ListDefault text={"회수 내역을"} />}
        {isSearch && !settleList.length && <EmptyScreen />}
        {isSearch && !!settleList.length && (
          <>
            <List.Content>
              {swapColumn.data.map((v, idx) => (
                <List.Row $ratio={v.ratio} key={idx}>
                  {v.title}
                </List.Row>
              ))}
            </List.Content>
            <Info.Wrapper>
              {settleList.map((v, idx) => (
                <SettleInfoDetail data={v} key={idx} />
              ))}
            </Info.Wrapper>
          </>
        )}
      </List.Container>
    </Wrapper>
  );
};
